import type { ConfidenceLevel } from '@/types/measurements';

const BADGE_STYLES: Record<ConfidenceLevel, string> = {
  high: 'bg-green-100 text-green-700',
  medium: 'bg-yellow-100 text-yellow-700',
  low: 'bg-red-100 text-red-700',
};

const BADGE_LABELS: Record<ConfidenceLevel, string> = {
  high: 'High',
  medium: 'Med',
  low: 'Low',
};

interface ConfidenceBadgeProps {
  level: ConfidenceLevel;
}

export function ConfidenceBadge({ level }: ConfidenceBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold ${BADGE_STYLES[level]}`}
    >
      {BADGE_LABELS[level]}
    </span>
  );
}
